// extracted by mini-css-extract-plugin
module.exports = {"textColor":"#f75d22","textColor2":"\"#F67743\"","backgroundColor":"#f75d22","redCOlor":"#db2020"};